import { render, staticRenderFns } from "./EventsPayments.vue?vue&type=template&id=2795cd62&scoped=true&"
import script from "./EventsPayments.vue?vue&type=script&lang=ts&"
export * from "./EventsPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795cd62",
  null
  
)

export default component.exports